import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { login } from '../../api/login/auth';
import { LOGIN_ALERT_REMOVE, SET_LOADING_FALSE } from '../../actions/types';
import store from '../../store';
import { CardBody } from 'reactstrap';

const Login = ({
  login,
  isAuthenticated,
  errMessage,
  isError,
  isErrorType,
  isMainLoading,
}) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  var url_string = window.location.href;
  var url = new URL(url_string);
  var c = url.searchParams.get('report');
  if (c !== null) sessionStorage.setItem('document_url_processing', c);
  else sessionStorage.removeItem('document_url_processing');

  const [showmsg, setShowmsg] = useState('d-none');
  const [eMessage, setEMessage] = useState(null);
  const [newpassEye, setNewpassEye] = useState(false);

  const { email, password } = formData;
  const onChange = (e) => {
    setEMessage(null);
    setShowmsg('d-none');
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    if (isError && isErrorType === 'LOGIN_FAILED') {
      setShowmsg('');
      setTimeout(() => {
        store.dispatch({
          type: LOGIN_ALERT_REMOVE,
        });
      }, 12000);
    } else {
      setShowmsg('d-none');
    }
  }, [isError, isErrorType]);
  const onSubmit = async (e) => {
    e.preventDefault();
    store.dispatch({ type: SET_LOADING_FALSE });
    if (email === '' || password === '') {
      setShowmsg('');
      setEMessage('Fields cannot be empty');
      setTimeout(() => {
        setEMessage(null);
        setShowmsg('d-none');
      }, 12000);
    } else {
      await login(email, password);
    }
  };

  if (isAuthenticated) {
    if (sessionStorage.getItem('role') === 'PROJECT-ADMIN') {
      window.location.href = '/inspection';
    }
    if (sessionStorage.getItem('role') === 'COMPANY-ADMIN') {
      window.location.href = '/inspection';
    }
    if (sessionStorage.getItem('role') === 'SUPER-USER') {
      window.location.href = '/inspection';
    }
    if (sessionStorage.getItem('role') === 'USER') {
      window.location.href = '/inspection#!';
    }
  }

  return (
    <Fragment>
      <div
        style={{
          width: '100%',
          borderRadius: '0px',
        }}
        className=' py-3 px-3 mt-4'
      >
        <CardBody className='pt-3 pb-3 pl-3 pr-3'>
          <form
            className='form-signin mt-0 mb-0 p-0 '
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit(e);
            }}
          >
            <h3 className='mb-2'>Sign in to account</h3>
            <p className='mb-3 pb-2'>Enter your email & password to login</p>
            <div className='form-group'>
              {/* <label>Email</label> */}
              <input
                type='text'
                className='form-control'
                placeholder='Email'
                autoFocus
                required
                name='email'
                onChange={(e) => onChange(e)}
                style={{ fontSize: '16px', height: '44px' }}
                value={email}
              />
            </div>
            <div className='form-group'>
              {/* <label>Password</label>  */}
              <input
                type={newpassEye ? 'text' : 'password'}
                name='password'
                className='form-control'
                placeholder='Password'
                required
                value={password}
                style={{ fontSize: '16px', height: '44px' }}
                onChange={(e) => onChange(e)}
              />
              <span
                toggle='#inputPassword'
                className={
                  'fa field-icon toggle-password ' +
                  (newpassEye ? 'fa-eye-slash' : 'fa-eye')
                }
                onClick={(e) => {
                  setNewpassEye(!newpassEye);
                }}
              ></span>

              <button
                className='btn btn-lg mb-2 mt-4 btn-primary btn-block btn-signin'
                type='submit'
                disabled={isMainLoading ? true : false}
              >
                {isMainLoading ? (
                  <i className='fa fa-spinner fa-spin'></i>
                ) : (
                  'Sign in'
                )}
              </button>
              <div className='col-12' style={{ overflow: 'auto' }}>
                <Link
                  to='/forgot-password'
                  style={{
                    width: '100%',
                    textAlign: 'right',
                    float: 'right',
                  }}
                  data-original-title=''
                  title=''
                >
                  Reset Password
                </Link>
              </div>
              <div className={'col-12 p-0 m-0 ' + showmsg}>
                <div
                  className='alert alert-danger alert-dismissible fade show mb-0 mt-3'
                  role='alert'
                >
                  {eMessage === null ? errMessage : eMessage}
                </div>
              </div>
            </div>
          </form>
        </CardBody>
      </div>
    </Fragment>
  );
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  isError: PropTypes.bool,
  errMessage: PropTypes.string,
  isErrorType: PropTypes.string,
  isMainLoading: PropTypes.bool,
};
const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isError: state.auth.isError,
  errMessage: state.auth.errMessage,
  isErrorType: state.auth.isErrorType,
  isMainLoading: state.auth.loading,
});
export default connect(mapStateToProps, { login })(Login);
